import React from "react";
import { Helmet } from "react-helmet-async";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

const WisdomTeeth = () => {
  const { t, i18n } = useTranslation();

  const data = t("WisdomTeeth", { returnObjects: true });

  return (
    <div
      className="container py-5 mt-5"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/wisdom-teeth"
        />

        <title>{data.seo.title}</title>
        <meta name="description" content={data.seo.description} />
        <meta name="keywords" content={data.seo.keywords} />

        <meta property="og:title" content={data.seo.ogTitle} />
        <meta property="og:description" content={data.seo.ogDescription} />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://slimsmile.ps/images/wisdom-teeth.jpg"
        />
        <meta
          property="og:url"
          content="https://slimsmile.ps/articles/wisdom-teeth"
        />
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {data.title}
      </h1>
      <h5 className="text-center mb-5">{data.subtitle}</h5>

      <p className="text-center text-muted">{data.author}</p>
      <p className="text-center text-muted">{data.location}</p>

      {Object.values(data.sections).map((section, i) => (
        <div key={i}>
          <h2 className="mt-4">{section.title}</h2>
          {section.text && <p>{section.text}</p>}
          {section.list && (
            <ul>
              {section.list.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          )}
          {section.note && <p>{section.note}</p>}
        </div>
      ))}

      <h2 className="mt-4">{data.sections.message.title}</h2>
      <p>
        <em>{data.sections.message.text}</em>
      </p>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {data.backBtn}
        </HashLink>
      </footer>
    </div>
  );
};

export default WisdomTeeth;
